module.exports = __webpack_public_path__ + "static/media/acorn.258db469.svg";